import './radioButton.scss'
import classNames from 'classnames'
import { memo } from 'react'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const RadioButton = memo(({ onToggleSelectMode, isChecked, value, isHidden }) => {
  const onChangeRadio = () => onToggleSelectMode(value)
  return (
    <div className={classNames('mode-option-container', { hidden: isHidden })}>
      <label className='radio' htmlFor={value}>
        {value ?
          <input id={value} onChange={onChangeRadio} type='radio' checked={isChecked} />
        : null}
        <div className={classNames('radio-button-circle', { checked: isChecked })} />
        <div className='mode-option-value'>{value}</div>
      </label>
    </div>
  )
})

export default RadioButton
